import React, { useState } from 'react';
import { images } from '../../../Constants/ImageUrls';
import { Controls } from './styled';
import { clicked_card_in_pdp } from './utils';

const RightNav = ({
  onClick,
  disabled,
  right,
  currentIndex,
  product,
  imgLength,
  isImageReview,
}) => {
  const [clickEffect, setClickEffect] = useState('');
  return (
    <Controls
      src={right ? images.carousel_right_arrow : images.carousel_left_arrow}
      alt=""
      className={`image-gallery-icon ${
        right ? 'image-gallery-right-nav' : 'image-gallery-left-nav'
      } ${clickEffect}`}
      disabled={disabled}
      onClick={(e) => {
        setClickEffect('lowOpacity');
        setTimeout(() => {
          setClickEffect('');
        }, 200);
        clicked_card_in_pdp(
          e,
          currentIndex,
          product,
          imgLength,
          'clicked_arrow',
          isImageReview,
        );
        onClick();
      }}
      aria-label={right ? 'Next Slide' : 'Prev Slide'}
      right={right}
    />
  );
};

export default RightNav;
